import { render, staticRenderFns } from "./comTypeApplyIndex.vue?vue&type=template&id=15fa2ea4&"
import script from "./comTypeApplyIndex.vue?vue&type=script&lang=js&"
export * from "./comTypeApplyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports